import React, { useEffect, useState } from "react";
import { collection, getDocs, getDoc, doc } from "firebase/firestore";
import { db } from "../../../config/firebase";
import Layout from "./Layout";
import { COLLECTION, SESSION } from "../../../data/constant";

export default function CampusUserManagement() {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);

        // 1️⃣ Get session
        const sessionId = localStorage.getItem(SESSION.CAMPUS_SESSION_ID);
        if (!sessionId) {
          console.error("❌ No session found");
          setLoading(false);
          return;
        }

        const sessionSnap = await getDoc(
          doc(db, COLLECTION.CAMPUS_SESSION, sessionId)
        );

        if (!sessionSnap.exists()) {
          console.error("❌ Session document not found");
          setLoading(false);
          return;
        }

        const { campusId, email: adminEmail } = sessionSnap.data();

        if (!adminEmail || !adminEmail.includes("@")) {
          console.error("❌ Invalid admin email in session");
          setLoading(false);
          return;
        }

        // 2️⃣ Validate campus exists (optional safety check)
        const campusSnap = await getDoc(
          doc(db, COLLECTION.CAMPUS, campusId)
        );

        if (!campusSnap.exists()) {
          console.error("❌ Campus document not found");
          setLoading(false);
          return;
        }

        // 3️⃣ Extract admin domain
        const adminDomain = adminEmail.toLowerCase().split("@")[1];

        // 4️⃣ Fetch all users
        const userSnap = await getDocs(
          collection(db, COLLECTION.USER)
        );

        const allUsers = userSnap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // 5️⃣ Filter users by domain
        const domainFilteredUsers = allUsers.filter((user) =>
          user.email?.toLowerCase().endsWith(`@${adminDomain}`)
        );

        setUsers(domainFilteredUsers);
        setFilteredUsers(domainFilteredUsers);
        setLoading(false);
      } catch (error) {
        console.error("🔥 Error fetching users:", error);
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  // 🔍 Search filter
  useEffect(() => {
    const lowerQuery = searchQuery.toLowerCase();

    const filtered = users.filter(
      (user) =>
        user.name?.toLowerCase().includes(lowerQuery) ||
        user.email?.toLowerCase().includes(lowerQuery) ||
        user.phoneNumber?.toString().includes(lowerQuery)
    );

    setFilteredUsers(filtered);
  }, [searchQuery, users]);

  return (
    <Layout
      userTableData={filteredUsers}
      isLoading={loading}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
    />
  );
}
